/* Publish by EComposer at 2026-09-29 05:53:35*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nc5b7cu1qzr"]=  window.__ectimmers["ecom-nc5b7cu1qzr"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-nc5b7cu1qzr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nc5b7cu1qzr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4k6hg102cup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4k6hg102cup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-682uot9eyrb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-682uot9eyrb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uzfziqkdbc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uzfziqkdbc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7lcbcmekurv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7lcbcmekurv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f9xdaimiyff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f9xdaimiyff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8utjo5vnz14').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8utjo5vnz14', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8kxz3ws26').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8kxz3ws26', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qdql15xc12k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qdql15xc12k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9rpw836qyak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9rpw836qyak', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ic2y0rrtvpn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ic2y0rrtvpn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h29ao8h263r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h29ao8h263r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwf7wkgn4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwf7wkgn4t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5fsotm1uo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5fsotm1uo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e6vbvzovrlp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e6vbvzovrlp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ypd6s1763b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypd6s1763b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cbe9cyq60km').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cbe9cyq60km', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txh3h745di').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txh3h745di', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-edgwj3favk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-edgwj3favk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t12yf69q3lo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t12yf69q3lo', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rwje2ewrvx"]=  window.__ectimmers["ecom-rwje2ewrvx"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-rwje2ewrvx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rwje2ewrvx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8ky1whyc0l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8ky1whyc0l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3572xo1x6qx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3572xo1x6qx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2dmjx3dgjwy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2dmjx3dgjwy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-04hb7jcxug7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-04hb7jcxug7a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdfxw193yr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdfxw193yr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-blb3z2e8vqi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-blb3z2e8vqi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z3wg6j6l38b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z3wg6j6l38b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2jxro28c9d4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2jxro28c9d4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}